import { Injectable, Injector } from '@angular/core';
import { BullhornAttachmentSource, IAttachmentSource } from 'attachment-source-lib';
import { BullhornAuthService } from 'auth-service-lib';
import { BullhornDataSourceApiService } from 'datasource-service-lib';
import { BullhornDocumentDestinationService } from 'document-destination-service-lib';
import { BullhornEntityMetadataService } from 'entity-metadata-service-lib';
import { BullhornEntityPathService } from 'entity-path-service-lib';
import { BullhornEntityPickerService } from 'entity-picker-lib';
import { BullhornFileDataSourceApiService } from 'file-datasource-service-lib';
import { BullhornIconService } from 'icon-service-lib';
import {
  IAuthService,
  IDataSourceApiService,
  IEntityMetadataService,
  IEntityPickerService,
  IEntityTypeOption,
  IFileDataSourceApiService,
  IIconService,
  ISharedServiceProviderService
} from 'interfaces-lib';
import { jwtDecode } from 'jwt-decode';
import { BullhornNamedEntityService, INamedEntityService } from 'named-entity-service-lib';
import { BullhornRecipientInfoService, IRecipientInfoService } from 'recipient-info-service-lib';
import { Observable } from 'rxjs';
import { BullhornTerminologyService, ITerminologyService } from 'terminology-lib';
import { BullhornEntityTypeMappingsService } from './bullhorn-entity-type-mappings.service';

@Injectable({ providedIn: 'root' })
export class BullhornSharedServiceProviderService implements ISharedServiceProviderService {
  constructor(private injector: Injector) {}

  getAuthService(): IAuthService {
    return this.injector.get(BullhornAuthService);
  }

  getDataSourceApiService(): IDataSourceApiService {
    return this.injector.get(BullhornDataSourceApiService);
  }

  getEntityMetadataService(): IEntityMetadataService {
    return this.injector.get(BullhornEntityMetadataService);
  }

  getIconService(): IIconService {
    return this.injector.get(BullhornIconService);
  }

  getAttachmentSourceService(): IAttachmentSource {
    return this.injector.get(BullhornAttachmentSource);
  }

  getEntityPickerService(): IEntityPickerService {
    return this.injector.get(BullhornEntityPickerService);
  }

  getRecipientInfoService(): IRecipientInfoService {
    return this.injector.get(BullhornRecipientInfoService);
  }

  getTerminologyService(): ITerminologyService {
    return this.injector.get(BullhornTerminologyService);
  }

  getNamedEntityService(): INamedEntityService {
    return this.injector.get(BullhornNamedEntityService);
  }

  getEntityPathService() {
    return this.injector.get(BullhornEntityPathService);
  }

  getDocumentDestinationService() {
    return this.injector.get(BullhornDocumentDestinationService);
  }

  getFileDataSourceApiService(): IFileDataSourceApiService {
    return this.injector.get(BullhornFileDataSourceApiService);
  }

  getCorpId(token: string): string {
    const decoded = jwtDecode<{ corporationId?: string }>(token);
    if (!decoded.corporationId) {
      throw new Error('corporationId not found in Bullhorn token');
    }
    return decoded.corporationId;
  }

  getEntityTypeOptions(parentEntityType: string): Observable<IEntityTypeOption[]> {
    return this.injector.get(BullhornEntityTypeMappingsService).getEntityTypeOptions(parentEntityType);
  }
}
